// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Labels = require("../../../reason/clients/components/Labels.bs.js");
let Callout = require("../../common/Components/Callout.bs.js");
let Tooltip = require("../../../reason/common/Tooltip.bs.js");
let AgentInfo = require("../../common/Agent/AgentInfo.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let PseudoJoin = require("../../../uikit/reason/helpers/PseudoJoin.bs.js");
let AuthSession = require("../../../utils/AuthSession.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let HtmlDisplayer = require("../../common/Components/HtmlDisplayer.bs.js");
let PropertyPrice = require("../../common/Property/PropertyPrice.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let BuyerNeed__Status = require("../../qa/AllInBuyerNeed/BuyerNeed__Status.bs.js");
let PropertyCardImage = require("../../common/PropertyCardImage.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RentalNeed__Status = require("../../qa/AllInRentalNeed/RentalNeed__Status.bs.js");
let RentalPropertyLease = require("../../common/Property/RentalPropertyLease.bs.js");
let ForSalePropertyLabels = require("../../common/Property/ForSalePropertyLabels.bs.js");
let RentalProperty__Status = require("../../qa/AllInRentalProperty/RentalProperty__Status.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ForSaleProperty__Status = require("../../qa/AllInForSaleProperty/ForSaleProperty__Status.bs.js");
let PropertyLocationForCard = require("../../property/PropertyLocationForCard.bs.js");
let QuietPropertyMatchPopup = require("../../client/ClientPage/QuietPropertyMatchPopup.bs.js");
let RentalPropertyAttributes = require("../../common/Property/RentalPropertyAttributes.bs.js");
let ForSalePropertyAttributes = require("../../common/Property/ForSalePropertyAttributes.bs.js");
let RentalNeedLeaseAttributes = require("../../client/RentalNeedLeaseAttributes.bs.js");
let ConversationsPageRelayCommon = require("./ConversationsPageRelayCommon.bs.js");
let ConversationPageSelectedConversationContext_broadcast_graphql = require("../../../__generated__/ConversationPageSelectedConversationContext_broadcast_graphql.bs.js");
let ConversationPageSelectedConversationContext_buyerNeed_graphql = require("../../../__generated__/ConversationPageSelectedConversationContext_buyerNeed_graphql.bs.js");
let ConversationPageSelectedConversationContext_rentalNeed_graphql = require("../../../__generated__/ConversationPageSelectedConversationContext_rentalNeed_graphql.bs.js");
let ConversationPageSelectedConversationContext_conversation_graphql = require("../../../__generated__/ConversationPageSelectedConversationContext_conversation_graphql.bs.js");
let ConversationPageSelectedConversationContext_rentalProperty_graphql = require("../../../__generated__/ConversationPageSelectedConversationContext_rentalProperty_graphql.bs.js");
let ConversationPageSelectedConversationContext_forSaleProperty_graphql = require("../../../__generated__/ConversationPageSelectedConversationContext_forSaleProperty_graphql.bs.js");
let ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql = require("../../../__generated__/ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql.bs.js");

function ConversationPageSelectedConversationContext$DetailsLink(props) {
  let entity = props.entity;
  let contextAgentId = props.contextAgentId;
  let clientId = props.clientId;
  let currentUserId = AuthSession.useCurrentUserId();
  let agentIsCurrentUser = currentUserId !== undefined && contextAgentId !== undefined ? currentUserId === contextAgentId : false;
  let button = JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
    size: "small",
    icon: "view-details",
    children: "View details"
  });
  if (agentIsCurrentUser && clientId !== undefined) {
    return JsxRuntime.jsx(ButtonsV5.Link.make, {
      href: "/my_clients/" + clientId,
      children: button
    });
  }
  let variant = entity.NAME;
  return JsxRuntime.jsx(ButtonsV5.Link.make, {
    href: variant === "RentalNeed" || variant === "BuyerNeed" ? "/client_needs/" + entity.VAL : "/properties/" + entity.VAL,
    children: button
  });
}

let DetailsLink = {
  make: ConversationPageSelectedConversationContext$DetailsLink
};

function minBedsDisplayString(x) {
  if (x !== 1) {
    return "Minimum " + x.toString() + " beds";
  } else {
    return "Minimum 1 bed";
  }
}

let convertFragment = ConversationPageSelectedConversationContext_buyerNeed_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationContext_buyerNeed_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_buyerNeed_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationContext_buyerNeed_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationContext_buyerNeed_graphql.node, convertFragment, fRef);
}

let BuyerNeedFragment_buyerNeedMatchingType_decode = ConversationPageSelectedConversationContext_buyerNeed_graphql.Utils.buyerNeedMatchingType_decode;

let BuyerNeedFragment_buyerNeedMatchingType_fromString = ConversationPageSelectedConversationContext_buyerNeed_graphql.Utils.buyerNeedMatchingType_fromString;

let BuyerNeedFragment = {
  buyerNeedMatchingType_decode: BuyerNeedFragment_buyerNeedMatchingType_decode,
  buyerNeedMatchingType_fromString: BuyerNeedFragment_buyerNeedMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationPageSelectedConversationContext$BuyerNeed(props) {
  let buyerNeed = RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_buyerNeed_graphql.node, convertFragment, props.buyerNeed);
  let match = buyerNeed.agent;
  let agentIsCurrentUser = AuthSession.useAgentIsCurrentUser(match !== undefined ? match.id : undefined);
  let match$1 = buyerNeed.client;
  let match$2 = buyerNeed.buyerNeedMatchingType;
  let match$3 = buyerNeed.headline;
  let tmp;
  let exit = 0;
  if (agentIsCurrentUser && match$1 !== undefined) {
    tmp = Stdlib_Option.getOr(ConversationsPageRelayCommon.Client.getClientNames(match$1.fragmentRefs), "Buyer");
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = match$2 !== undefined && (match$2 === "BROADCAST" || match$2 === "QUIET") ? (
        match$2 === "BROADCAST" ? (
            match$3 !== undefined ? match$3 : ""
          ) : "Quiet buyer"
      ) : "";
  }
  let match$4 = buyerNeed.buyerNeedMatchingType;
  let tmp$1;
  tmp$1 = match$4 === "QUIET" ? JsxRuntime.jsx(Labels.QuietBuyerLabel.make, {}) : null;
  let match$5 = buyerNeed.areas;
  let tmp$2;
  if (match$5 !== undefined) {
    let edges = match$5.edges;
    tmp$2 = edges !== undefined ? JsxRuntime.jsx(PseudoJoin.make, {
        items: Stdlib_Array.keepSome(edges).map(e => JsxRuntime.jsx(Tooltip.make, {
          label: e.node.label,
          children: JsxRuntime.jsx("span", {
            children: e.node.name,
            className: "inline-block md:underline md:decoration-dotted md:decoration-zinc-400"
          })
        })),
        with_: ", "
      }) : null;
  } else {
    tmp$2 = null;
  }
  let match$6 = buyerNeed.priceRange;
  let remarks = buyerNeed.remarks;
  let match$7 = buyerNeed.client;
  let match$8 = buyerNeed.buyerNeedMatchingType;
  let tmp$3;
  let exit$1 = 0;
  if (agentIsCurrentUser) {
    if (match$7 !== undefined) {
      tmp$3 = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ButtonsV5.Link.make, {
          href: "/my_clients/" + match$7.id,
          children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            size: "small",
            icon: "view-details",
            children: "View details"
          })
        }),
        className: "mt-4"
      });
    } else {
      exit$1 = 1;
    }
  } else if (match$8 === "BROADCAST") {
    exit$1 = 1;
  } else {
    tmp$3 = null;
  }
  if (exit$1 === 1) {
    tmp$3 = JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(ButtonsV5.Link.make, {
        href: "/client_needs/" + buyerNeed.id,
        children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
          size: "small",
          icon: "view-details",
          children: "View details"
        })
      }),
      className: "mt-4"
    });
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    children: tmp,
                    className: "text-xl text-gray-700 font-semibold"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      tmp$1,
                      JsxRuntime.jsx(BuyerNeed__Status.make, {
                        buyerNeed: buyerNeed.fragmentRefs
                      })
                    ]
                  })
                ],
                className: "flex flex-row space-x-4 items-baseline"
              }),
              JsxRuntime.jsx("div", {
                children: tmp$2,
                className: "text-gray-500 mt-4"
              })
            ]
          }),
          JsxRuntime.jsx("div", {
            children: match$6 !== undefined ? JsxRuntime.jsx("span", {
                children: match$6.minPrice.formatted + " - " + match$6.maxPrice.formatted,
                className: "text-tan-gold"
              }) : null,
            className: "text-2xl font-medium ml-8 shrink-0"
          })
        ],
        className: "flex flex-row justify-between"
      }),
      JsxRuntime.jsx("div", {
        children: Stdlib_Option.getOr(buyerNeed.propertyTypes, []).map(p => p.displayName).concat(Stdlib_Array.keepSome([Stdlib_Option.map(buyerNeed.minBeds, minBedsDisplayString)])).join(", "),
        className: "text-gray-500"
      }),
      JsxRuntime.jsx("div", {
        children: remarks !== undefined ? JsxRuntime.jsx(HtmlDisplayer.make, {
            text: remarks
          }) : null
      }),
      JsxRuntime.jsx("div", {
        children: tmp$3
      })
    ],
    className: "border rounded-md p-4 flex flex-col space-y-4"
  });
}

let BuyerNeed = {
  BuyerNeedFragment: BuyerNeedFragment,
  Status: undefined,
  make: ConversationPageSelectedConversationContext$BuyerNeed
};

let convertFragment$1 = ConversationPageSelectedConversationContext_rentalNeed_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationContext_rentalNeed_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_rentalNeed_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationContext_rentalNeed_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationContext_rentalNeed_graphql.node, convertFragment$1, fRef);
}

let RentalNeedFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function ConversationPageSelectedConversationContext$RentalNeed(props) {
  let rentalNeed = RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_rentalNeed_graphql.node, convertFragment$1, props.rentalNeed);
  let match = rentalNeed.agent;
  let agentIsCurrentUser = AuthSession.useAgentIsCurrentUser(match !== undefined ? match.id : undefined);
  let match$1 = rentalNeed.areas;
  let tmp;
  if (match$1 !== undefined) {
    let edges = match$1.edges;
    tmp = edges !== undefined ? JsxRuntime.jsx(PseudoJoin.make, {
        items: Stdlib_Array.keepSome(edges).map(e => JsxRuntime.jsx(Tooltip.make, {
          label: e.node.label,
          children: JsxRuntime.jsx("span", {
            children: e.node.name,
            className: "inline-block md:underline md:decoration-dotted md:decoration-zinc-400"
          })
        })),
        with_: ", "
      }) : null;
  } else {
    tmp = null;
  }
  let match$2 = rentalNeed.priceRange;
  let remarks = rentalNeed.remarks;
  let match$3 = rentalNeed.client;
  let tmp$1;
  let exit = 0;
  if (agentIsCurrentUser && match$3 !== undefined) {
    tmp$1 = JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(ButtonsV5.Link.make, {
        href: "/my_clients/" + match$3.id,
        children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
          size: "small",
          icon: "view-details",
          children: "View details"
        })
      }),
      className: "mt-4"
    });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp$1 = JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(ButtonsV5.Link.make, {
        href: "/client_needs/" + rentalNeed.id,
        children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
          size: "small",
          icon: "view-details",
          children: "View details"
        })
      }),
      className: "mt-4"
    });
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    children: Stdlib_Option.getOr(rentalNeed.headline, ""),
                    className: "text-xl text-gray-700 font-semibold"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(RentalNeed__Status.make, {
                      rentalNeed: rentalNeed.fragmentRefs
                    })
                  })
                ],
                className: "flex flex-row space-x-4 items-baseline"
              }),
              JsxRuntime.jsx("div", {
                children: tmp,
                className: "text-gray-500 mt-4"
              })
            ]
          }),
          JsxRuntime.jsx("div", {
            children: match$2 !== undefined ? JsxRuntime.jsx("span", {
                children: match$2.minPrice.formatted + " - " + match$2.maxPrice.formatted + "/month",
                className: "text-tan-gold"
              }) : null,
            className: "text-2xl font-medium ml-8 shrink-0"
          })
        ],
        className: "flex flex-row justify-between"
      }),
      JsxRuntime.jsx("div", {
        children: Stdlib_Option.getOr(rentalNeed.propertyTypes, []).map(p => p.displayName).concat(Stdlib_Array.keepSome([Stdlib_Option.map(rentalNeed.minBeds, minBedsDisplayString)])).join(", "),
        className: "text-gray-500"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(RentalNeedLeaseAttributes.make, {
          rentalNeed: rentalNeed.fragmentRefs
        })
      }),
      JsxRuntime.jsx("div", {
        children: remarks !== undefined ? JsxRuntime.jsx(HtmlDisplayer.make, {
            text: remarks
          }) : null
      }),
      JsxRuntime.jsx("div", {
        children: tmp$1
      })
    ],
    className: "border rounded-md p-4 flex flex-col space-y-4"
  });
}

let RentalNeed = {
  RentalNeedFragment: RentalNeedFragment,
  Status: undefined,
  make: ConversationPageSelectedConversationContext$RentalNeed
};

let convertFragment$2 = ConversationPageSelectedConversationContext_broadcast_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationContext_broadcast_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_broadcast_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationContext_broadcast_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationContext_broadcast_graphql.node, convertFragment$2, fRef);
}

let BroadcastFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function ConversationPageSelectedConversationContext$MessageBroadcast(props) {
  let broadcast = RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_broadcast_graphql.node, convertFragment$2, props.broadcast);
  let match = broadcast.agent;
  let body = broadcast.body;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: match !== undefined ? JsxRuntime.jsx(AgentInfo.make, {
            agent: match.fragmentRefs
          }) : null
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: broadcast.category.shortName,
            className: "text-gray-400 uppercase"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("h3", {
              children: Stdlib_Option.getOr(broadcast.subject, ""),
              className: "text-xl font-semibold"
            })
          }),
          body !== undefined ? JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(HtmlDisplayer.make, {
                text: body
              })
            }) : null
        ]
      })
    ],
    className: "border rounded-md p-4 flex flex-col space-y-2"
  });
}

let MessageBroadcast = {
  BroadcastFragment: BroadcastFragment,
  make: ConversationPageSelectedConversationContext$MessageBroadcast
};

let convertFragment$3 = ConversationPageSelectedConversationContext_forSaleProperty_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationContext_forSaleProperty_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_forSaleProperty_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationContext_forSaleProperty_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationContext_forSaleProperty_graphql.node, convertFragment$3, fRef);
}

let PropertyFragment_forSalePropertyMatchingType_decode = ConversationPageSelectedConversationContext_forSaleProperty_graphql.Utils.forSalePropertyMatchingType_decode;

let PropertyFragment_forSalePropertyMatchingType_fromString = ConversationPageSelectedConversationContext_forSaleProperty_graphql.Utils.forSalePropertyMatchingType_fromString;

let PropertyFragment = {
  forSalePropertyMatchingType_decode: PropertyFragment_forSalePropertyMatchingType_decode,
  forSalePropertyMatchingType_fromString: PropertyFragment_forSalePropertyMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function ConversationPageSelectedConversationContext$ForSaleProperty(props) {
  let property = RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_forSaleProperty_graphql.node, convertFragment$3, props.property);
  let match = property.agentV2;
  let agentId;
  if (match !== undefined && match.__typename === "VisibleForSalePropertyAgent") {
    let match$1 = match.agent;
    agentId = match$1 !== undefined ? match$1.id : undefined;
  } else {
    agentId = undefined;
  }
  let match$2 = property.client;
  let clientId = match$2 !== undefined ? match$2.id : undefined;
  let match$3 = property.images;
  let imageSrc;
  if (match$3 !== undefined) {
    let match$4 = match$3.edges;
    if (match$4.length !== 1) {
      imageSrc = undefined;
    } else {
      let match$5 = match$4[0];
      imageSrc = match$5 !== undefined ? match$5.node.url : undefined;
    }
  } else {
    imageSrc = undefined;
  }
  let description = property.description;
  let match$6 = property.matchingType;
  let tmp;
  let exit = 0;
  if (match$6 !== undefined) {
    let exit$1 = 0;
    if (match$6 === "BROADCAST" || match$6 === "QUIET_ANONYMOUS" || match$6 === "ONE_WAY" || match$6 === "QUIET") {
      switch (match$6) {
        case "QUIET" :
        case "QUIET_ANONYMOUS" :
          exit$1 = 2;
          break;
        default:
          exit = 1;
      }
    } else {
      exit = 1;
    }
    if (exit$1 === 2) {
      tmp = JsxRuntime.jsx(QuietPropertyMatchPopup.FromDetailsButton.make, {
        propertyNodeId: property.nodeId
      });
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(ConversationPageSelectedConversationContext$DetailsLink, {
      clientId: clientId,
      contextAgentId: agentId,
      entity: {
        NAME: "ForSaleProperty",
        VAL: property.id
      }
    });
  }
  return JsxRuntime.jsxs("div", {
    children: [
      imageSrc !== undefined ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("img", {
            className: "w-full h-full object-cover absolute inset-0",
            alt: "Property image",
            src: imageSrc
          }),
          className: "w-full h-32 lg:w-1/4 lg:h-auto relative"
        }) : null,
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(PropertyLocationForCard.make, {
                        property: property.fragmentRefs
                      }),
                      JsxRuntime.jsx(ForSalePropertyLabels.make, {
                        property: property.fragmentRefs
                      })
                    ],
                    className: "flex flex-row space-x-4"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(ForSaleProperty__Status.make, {
                        property: property.fragmentRefs,
                        size: "sm"
                      }),
                      className: "mt-4"
                    })
                  })
                ],
                className: "flex flex-col space-y-2"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(PropertyPrice.make, {
                  property: property.fragmentRefs,
                  size: "medium"
                })
              })
            ],
            className: "flex flex-col lg:flex-row justify-between gap-4 lg:items-start"
          }),
          description !== undefined ? JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(HtmlDisplayer.make, {
                text: description
              })
            }) : null,
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ForSalePropertyAttributes.make, {
              property: property.fragmentRefs,
              size: "sm"
            })
          }),
          JsxRuntime.jsx("div", {
            children: tmp
          })
        ],
        className: "flex flex-col space-y-4 p-4 border grow"
      })
    ],
    className: "flex flex-col lg:flex-row"
  });
}

let ForSaleProperty = {
  PropertyFragment: PropertyFragment,
  Status: undefined,
  make: ConversationPageSelectedConversationContext$ForSaleProperty
};

let convertFragment$4 = ConversationPageSelectedConversationContext_rentalProperty_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationContext_rentalProperty_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_rentalProperty_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationContext_rentalProperty_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationContext_rentalProperty_graphql.node, convertFragment$4, fRef);
}

let PropertyFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

function ConversationPageSelectedConversationContext$RentalProperty(props) {
  let property = RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_rentalProperty_graphql.node, convertFragment$4, props.property);
  let agentId = Stdlib_Option.map(property.agent, a => a.id);
  let match = property.client;
  let clientId = match !== undefined ? match.id : undefined;
  let match$1 = property.images;
  let imageFragmentRefs;
  if (match$1 !== undefined) {
    let match$2 = match$1.edges;
    if (match$2.length !== 1) {
      imageFragmentRefs = undefined;
    } else {
      let match$3 = match$2[0];
      imageFragmentRefs = match$3 !== undefined ? Primitive_option.some(match$3.node.fragmentRefs) : undefined;
    }
  } else {
    imageFragmentRefs = undefined;
  }
  let description = property.description;
  return JsxRuntime.jsxs("div", {
    children: [
      imageFragmentRefs !== undefined ? JsxRuntime.jsx(PropertyCardImage.make, {
          image: Primitive_option.valFromOption(imageFragmentRefs)
        }) : null,
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(PropertyLocationForCard.make, {
                      property: property.fragmentRefs
                    })
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(RentalProperty__Status.make, {
                        property: property.fragmentRefs,
                        size: "sm"
                      }),
                      className: "mt-4"
                    })
                  })
                ],
                className: "flex flex-col space-y-2"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(PropertyPrice.make, {
                  property: property.fragmentRefs,
                  size: "medium"
                })
              })
            ],
            className: "flex flex-col lg:flex-row justify-between gap-4 lg:items-start"
          }),
          description !== undefined ? JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(HtmlDisplayer.make, {
                text: description
              })
            }) : null,
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(RentalPropertyAttributes.make, {
                property: property.fragmentRefs,
                size: "sm"
              }),
              JsxRuntime.jsx(RentalPropertyLease.make, {
                property: property.fragmentRefs,
                size: "sm"
              })
            ]
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ConversationPageSelectedConversationContext$DetailsLink, {
              clientId: clientId,
              contextAgentId: agentId,
              entity: {
                NAME: "RentalProperty",
                VAL: property.id
              }
            })
          })
        ],
        className: "flex flex-col space-y-4 p-4 border grow"
      })
    ],
    className: "flex flex-row"
  });
}

let RentalProperty = {
  PropertyFragment: PropertyFragment$1,
  Status: undefined,
  make: ConversationPageSelectedConversationContext$RentalProperty
};

let convertFragment$5 = ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql.node, convertFragment$5, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql.node, convertFragment$5, fRef);
}

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql.node, convertFragment$5);
}

function readResolverFragment$5(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql.node, convertFragment$5, fRef);
}

let AgentFragment_membershipStatusV5_decode = ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql.Utils.membershipStatusV5_decode;

let AgentFragment_membershipStatusV5_fromString = ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql.Utils.membershipStatusV5_fromString;

let AgentFragment = {
  membershipStatusV5_decode: AgentFragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: AgentFragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$5,
  useOpt: useOpt$5,
  readResolverFragment: readResolverFragment$5
};

function ConversationPageSelectedConversationContext$RemovedContextCard(props) {
  let agent = useOpt$5(props.agent);
  let entityStr = ConversationsPageRelayCommon.EntityType.toString(props.entityType);
  let tmp;
  if (agent !== undefined) {
    let match = agent.membershipStatus;
    tmp = match === "TERMINATED" ? "has been removed as " + agent.displayName + " no longer has an active subscription on TAN" : "has been removed from TAN";
  } else {
    tmp = "has been removed from TAN";
  }
  let title = "This " + entityStr + " " + tmp;
  return JsxRuntime.jsx(Callout.Info.make, {
    title: title
  });
}

let RemovedContextCard = {
  AgentFragment: AgentFragment,
  make: ConversationPageSelectedConversationContext$RemovedContextCard
};

let conversationContextTypeV5_decode = ConversationPageSelectedConversationContext_conversation_graphql.Utils.conversationContextTypeV5_decode;

let convertFragment$6 = ConversationPageSelectedConversationContext_conversation_graphql.Internal.convertFragment;

function waitForFragmentData$6(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationContext_conversation_graphql.node, convertFragment$6, fRef);
}

function use$6(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_conversation_graphql.node, convertFragment$6, fRef);
}

function useOpt$6(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationContext_conversation_graphql.node, convertFragment$6);
}

function readResolverFragment$6(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationContext_conversation_graphql.node, convertFragment$6, fRef);
}

let ConversationFragment_conversationContextTypeV5_fromString = ConversationPageSelectedConversationContext_conversation_graphql.Utils.conversationContextTypeV5_fromString;

let ConversationFragment = {
  conversationContextTypeV5_decode: conversationContextTypeV5_decode,
  conversationContextTypeV5_fromString: ConversationFragment_conversationContextTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$6,
  waitForFragmentData: waitForFragmentData$6,
  use: use$6,
  useOpt: useOpt$6,
  readResolverFragment: readResolverFragment$6
};

function ConversationPageSelectedConversationContext(props) {
  let conversationContext = RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_conversation_graphql.node, convertFragment$6, props.conversationContext);
  if (conversationContext === undefined) {
    return null;
  }
  switch (conversationContext.__typename) {
    case "AvailableConversationContext" :
      let context = conversationContext.context;
      if (context === undefined) {
        return null;
      }
      switch (context.__typename) {
        case "BuyerNeedV5" :
          return JsxRuntime.jsx(ConversationPageSelectedConversationContext$BuyerNeed, {
            buyerNeed: context.fragmentRefs
          });
        case "ForSalePropertyV5" :
          return JsxRuntime.jsx(ConversationPageSelectedConversationContext$ForSaleProperty, {
            property: context.fragmentRefs
          });
        case "MessageBroadcast" :
          return JsxRuntime.jsx(ConversationPageSelectedConversationContext$MessageBroadcast, {
            broadcast: context.fragmentRefs
          });
        case "RentalNeedV5" :
          return JsxRuntime.jsx(ConversationPageSelectedConversationContext$RentalNeed, {
            rentalNeed: context.fragmentRefs
          });
        case "RentalPropertyV5" :
          return JsxRuntime.jsx(ConversationPageSelectedConversationContext$RentalProperty, {
            property: context.fragmentRefs
          });
        case "__unselected" :
          return null;
      }
    case "RemovedConversationContext" :
      let entityType = conversationContextTypeV5_decode(conversationContext.entityType);
      if (entityType !== undefined) {
        return JsxRuntime.jsx(ConversationPageSelectedConversationContext$RemovedContextCard, {
          agent: Primitive_option.some(conversationContext.agent.fragmentRefs),
          entityType: entityType
        });
      } else {
        return null;
      }
    case "__unselected" :
      return null;
  }
}

let Buttons;

let make = ConversationPageSelectedConversationContext;

exports.Buttons = Buttons;
exports.DetailsLink = DetailsLink;
exports.minBedsDisplayString = minBedsDisplayString;
exports.BuyerNeed = BuyerNeed;
exports.RentalNeed = RentalNeed;
exports.MessageBroadcast = MessageBroadcast;
exports.ForSaleProperty = ForSaleProperty;
exports.RentalProperty = RentalProperty;
exports.RemovedContextCard = RemovedContextCard;
exports.ConversationFragment = ConversationFragment;
exports.make = make;
/* Labels Not a pure module */
